import axios from '@axios'

export default {
  namespaced: true,
  state: {
    carteiraData: null,
  },
  getters: {},
  mutations: {
    SET_CARTEIRA_DATA(state, data) {
      state.carteiraData = data
    },
  },

  actions: {

    getCarteira({ commit, state }, { cache, corretora = 'BINANCE' }) {
      // Criar chave única para cache baseada na corretora
      const cacheKey = `${corretora}_carteira`
      if (cache === true && state.carteiraData != null && state.carteiraData[cacheKey] != null) {
        return state.carteiraData[cacheKey]
      }
      return new Promise((resolve, reject) => {
        axios.get('/usuario-info/carteira', {
          params: { corretora },
        })
          .then(response => {
            // Atualizar cache com chave específica da corretora
            const currentData = state.carteiraData || {}
            currentData[cacheKey] = response.data
            commit('SET_CARTEIRA_DATA', currentData)
            resolve(response.data)
          })
          .catch(error => { reject(error) })
      })
    },

    getCreditoDesempenho() {
      return new Promise((resolve, reject) => {
        axios.get('/usuario-info/credito')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getSaldo(context, { symbol, corretora = 'BINANCE' }) {
      return new Promise((resolve, reject) => {
        axios.get(`/usuario-info/saldo/${symbol}`, {
          params: { corretora },
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    isVerificaAssinaturaAtiva() {
      return new Promise((resolve, reject) => {
        axios.get('/usuario-info/verifica-assinatura/spot')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getCheckList() {
      return new Promise((resolve, reject) => {
        axios.get('usuario-configuracao/checklist')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    setCheckList(context, data) {
      return new Promise((resolve, reject) => {
        axios.post('usuario-configuracao/checklist', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
